export const GA_MEASUREMENT_ID = "G-MG53B1ELS2";
export const AW_CONVERSION_ID = "AW-439184315";
export const UA_TRACKING_ID = "UA-152899517-1";
export const GTM_TRACKING_ID = "GTM-NMNN6MX";

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  if (typeof gtag !== "undefined") {
    gtag("config", GA_MEASUREMENT_ID, {
      page_path: url,
    });
    gtag("config", UA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  if (typeof gtag !== "undefined") {
    gtag("event", action, {
      send_to: [GA_MEASUREMENT_ID, UA_TRACKING_ID],
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
